<template>
  <div id="member-write-form-template">
    <h2 class="show-title">조직도</h2>
      <div class="organization-table-edit">
		<div class="col-md-4">
		  <div class="org-table-box">
		      	기관명
            <div class="t-btn-box">
              <button type="button" class="btn btn--light-gray--org" @click="addTab">추가</button>
	        </div>
		  </div>

          <div class="org-table-box org-table-box-input-1" v-for="(orgObj, index) in orgObjList" style="display: inline-flex; align-items: center;">
            <input type="radio" name="orgName" @click="radioClick(index)" :value="index" v-model="selectedOrg" title="orgName 선택">
            <input type="text" placeholder="기관명을 입력해 주세요." class="input__text input-w80" style="margin-left: 2%;"
                   v-model="orgObj.orgName" :id="`inputOgr${index}`" title="기관명을 입력해 주세요.">
            <div style="display: inline-flex; margin-left: 3%; margin-right: 3%;">
              <button type="button" class="btn grey" Style="margin-left:10px;" @click="upSlides('org',index)" style="position: initial;margin-left:10px;display: inline-block;">up</button>
              <button type="button" class="btn grey" @click="downSlides('org',index)" style="position: initial;margin-left:10px;display: inline-block;">down</button>
            </div>
            <div class="t-btn-box">
	          <button type="button" class="btn grey" @click="removeTab(index)" v-if="orgObjList.length > 1" style="display: inline-block;">삭제</button>
	        </div>
		  </div>
		</div>

        <div class="col-md-8">
          <div class="org-table-box org-table-box-input-2">
            <div class="input-top-tit"><input type="text" placeholder="부서명을 입력해 주세요." class="input__text" v-model="addDeptNm" id="testInput" title="부서명을 입력해 주세요."></div>
            <input type="text" placeholder="직위을 입력해 주세요." class="input__text" v-model="addPosition" title="직위을 입력해 주세요.">
            <input type="text" placeholder="이름을 입력해 주세요." class="input__text" v-model="addName" title="이름을 입력해 주세요.">
            <input type="text" placeholder="연락처를 입력해 주세요." class="input__text" v-model="addTel" title="연락처를 입력해 주세요.">
            <!-- <input type="text" placeholder="이메일을 입력해 주세요." class="input__text" v-model="addEmail" title="이메일을 입력해 주세요."> -->
            <input type="text" placeholder="이력을 입력해 주세요." class="input__text" v-model="addHistory" title="이력을 입력해 주세요.">
            <div class="t-btn-box">
              <button type="button" class="btn btn--light-gray--org" @click="addDept">추가</button>
            </div>
          </div>

          <div class="abb-organization-table" v-for="(deptObj, index) in deptObjList">
            <label>
              <input type="checkbox" v-model="deptObj.deptChk" :checked="deptObj.deptChk" title="선택 선택" />
              담당자 다수인 경우 체크 해 주세요.(담당자 정보 추가입력이 가능합니다.)
            </label>
            <div class="org-table-box org-table-box-input-2" v-for="(desc, idx) in deptObj.deptDesc">
              <div class="input-top-tit">
                <input type="text" placeholder="부서명을 입력해 주세요." class="input__text" v-model="deptObj.deptName" v-if="idx === 0" title="부서명을 입력해 주세요.">
                <div style="display: inline-flex; margin-left: 60%;" v-if="idx === 0">
                  <button type="button" class="btn grey" Style="margin-left:10px;" @click="upSlides('dept1', index)" style="position: initial;margin-left:10px;display: inline-block;">up</button>
                  <button type="button" class="btn grey" @click="downSlides('dept1', index)" style="position: initial;margin-left:10px;display: inline-block;">down</button>
                </div>
              </div>
              <input type="text" placeholder="직위을 입력해 주세요." class="input__text" v-model="desc.position" title="직위을 입력해 주세요.">
              <input type="text" placeholder="이름을 입력해 주세요." class="input__text" v-model="desc.name" title="이름을 입력해 주세요.">
              <input type="text" placeholder="연락처를 입력해 주세요." class="input__text" v-model="desc.tel" title="연락처를 입력해 주세요.">
              <!-- <input type="text" placeholder="이메일을 입력해 주세요." class="input__text" v-model="desc.email" title="이메일을 입력해 주세요."> -->
              <input type="text" placeholder="약력을 입력해 주세요." class="input__text" v-model="desc.history" title="약력을 입력해 주세요.">
              <div class="t-btn-box">
                <button type="button" class="btn btn--light-gray--org"
                        v-if="idx === 0 && deptObj.deptChk === true" @click="add(index)">추가</button>
                <button type="button" class="btn grey" @click="remove(index, idx)">삭제</button>
              </div>
              <div style="display: inline-flex; margin-left: 69%;">
                <button type="button" class="btn grey" Style="margin-left:10px;" @click="upSlides(index, idx)" style="position: initial;margin-left:10px;display: inline-block;">up</button>
                <button type="button" class="btn grey" @click="downSlides(index, idx)" style="position: initial;margin-left:10px;display: inline-block;">down</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-submit-gruop">
	   	  <button type="button" class="form-submit__btn btn--blue-line" @click="saveOrgInfo('no')">저장</button>
		    <button type="button" class="form-submit__btn gray1" @click="cancel">취소</button>
		  </div>
      <span style="display: none;" v-html="content"></span>
    </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'member-write-form-template',
    props: ['moduleId', 'orgCode'],
    components: {
    },
    data() {
      return {
        type: '',
        name: '',
        desc: '',
        slug: '',
        modules: [],
        content: '',
        orgObjList: [],
        selectedOrg: -1,
        deptObjList: [],
        addDeptNm: '',
        addPosition: '',
        addName: '',
        addTel: '',
        addEmail: '',
        addHistory: '',
        orgHtml: '',
        tempObject: [],
        orgObjListIndex: -1,
      };
    },
    methods: {
      getOrgInfo() {
        Axios.get(`/api/organization/${this.moduleId}`, { params: { org: this.orgCode } }).then((res) => {
          this.name = res.data.name;
          this.type = res.data.type;
          this.desc = res.data.desc;
          this.slug = res.data.slug;
          this.modules = res.data.staticModule.modules;
          this.content = res.data.staticModule.modules[0].content;
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      },
      saveOrgInfo(flag) {
        let bFlag = true;
        for (let i = 0; i < this.orgObjList.length; i += 1) {
          if (this.orgObjList[i].orgName === '') {
            alert('기관명을 입력하세요.');
            $(`#inputOgr${i}`).focus();
            this.selectedOrg = i;
            this.radioClick(this.selectedOrg);
            bFlag = false;
            break;
          }
        }

        if (bFlag) {
          let tabButton = '';
          let tabSelect = '';
          for (let i = 0; i < this.orgObjList.length; i += 1) {
            const tabId = (i + 1) < 10 ? `0${i + 1}` : `${i + 1}`;
            if (i % 5 === 0) {
              tabButton += `<li class="first-bar"> <a href="#tab${tabId}" id="focusTab${tabId}">${this.orgObjList[i].orgName}</a></li>`;
            } else {
              tabButton += `<li><a href="#tab${tabId}" id="focusTab${tabId}">${this.orgObjList[i].orgName}</a></li>`;
            }
            tabSelect += `<option value="#tab${tabId}">${this.orgObjList[i].orgName}</option>`;
          }

          this.orgHtml = `<div class="title-bar-wrapper">
                           <div class="container">
                             <h1 class="title-bar__title">조직도</h1>
                             <p class="title-bar__desc">서울시민의 가까이 머물며, 서울시민과 함께하겠습니다.</p>
                             <p style="text-align:right" id="org-modify"> <a href="org-modify.do" class="btn--light-gray--org sm-btn">조직도 편집</a></p>
                           </div>
                         </div>
                         <div class="container organization">
                           <h4>서울시민의 가까이 머물며, 서울시민과 함께하겠습니다.</h4>
                           <p class="title-bar"></p>
                           <p>재단본부와 캠퍼스의 전 직원은 각자의 자리에서 책임을 다하며 서울시민과 함께하고 있습니다. 항상 여러분의 목소리에 귀 기울이겠습니다.</p>
                           <!--<p class="intro_img web_img"><img src="/images/img/organization.png" alt="조직도"/></p> -->
                           <p class="intro_img mobile_img"></p>
                           <div class="tabs">
                             <div class="tab-button-outer">
                               <ul id="tab-button" class="clearfix">
                     ${tabButton}
                               </ul>
                             </div>
                             <div class="tab-select-outer">
                               <select id="tab-select" title="tab-select 선택">
                     ${tabSelect}
                               </select>
                             </div>`;

          let deptDesc = '';
          for (let i = 0; i < this.orgObjList.length; i += 1) {
            const tabId = (i + 1) < 10 ? `0${i + 1}` : `${i + 1}`;

            deptDesc += `<div id="tab${tabId}" class="tab-contents">
                        <div role="tabpanel" class="member-list tab-pane active" id="foundation${i}">`;
            for (let j = 0; j < this.orgObjList[i].deptList.length; j += 1) {
              const dept = (j + 1) < 10 ? `0${j + 1}` : `${j + 1}`;
              deptDesc += `<dl class="clearfix">
                            <dt id="tab${tabId}_deptId${dept}">${this.orgObjList[i].deptList[j].deptName}</dt>`;

              for (let k = 0; k < this.orgObjList[i].deptList[j].deptDesc.length; k += 1) {
                const posId = (k + 1) < 10 ? `0${k + 1}` : `${k + 1}`;
                if (k === 0) {
                  deptDesc += '<dd>';
                } else {
                  deptDesc += '<dd class="sub-list">';
                }

                const position = this.orgObjList[i].deptList[j].deptDesc[k].position;
                const name = this.orgObjList[i].deptList[j].deptDesc[k].name;
                const tel = this.orgObjList[i].deptList[j].deptDesc[k].tel;
                const email = this.orgObjList[i].deptList[j].deptDesc[k].email;
                const history = this.orgObjList[i].deptList[j].deptDesc[k].history;

                if (position) {
                  deptDesc += `<p class="member-position" id="tab${tabId}_deptId${dept}_posId${posId}">${position}</p>`;
                }

                if (name) {
                  deptDesc += `<p class="member-name">${name}</p>`;
                }

                if (tel) {
                  deptDesc += `<p class="member-tel">${tel}</p>`;
                }

                if (email) {
                  deptDesc += `<p class="member-email">${email}</p>`;
                }

                if (history) {
                  deptDesc += `<p class="member-history">${history}</p>`;
                }
                deptDesc += '</dd>';
              }
              deptDesc += '</dl>';
            }
            deptDesc += '<dl class="clearfix"><dt></dt><dd></dd></dl>';
            deptDesc += '</div>';
            deptDesc += '</div>';
          }
          deptDesc += '</div>';
          deptDesc += '</div>';
          this.orgHtml += deptDesc;

          this.modules[0].content = this.orgHtml;
          const staticParams = {
            name: this.name,
            type: this.type,
            desc: this.desc,
            slug: this.slug,
            staticModule: { modules: this.modules },
          };
          let moduleParameter = {};
          moduleParameter = staticParams;
          Axios.put(`/api/organization/${this.moduleId}`, moduleParameter, { params: { org: this.orgCode } }).then(() => {
            if (flag === 'pass') {
              location.reload();
            } else {
              alert('저장되었습니다.');
              location.href = `/${this.orgCode}/organization.do`;
            }
          }).catch((e) => {
            alert(e);
          });
        }
      },
      cancel() {
        location.href = `/${this.orgCode}/organization.do`;
      },
      // 기관명 선택
      radioClick(index) {
        this.deptObjList = [];
        this.deptObjList = this.orgObjList[index].deptList;
      },
      // 기관 추가
      addTab() {
        this.orgObjList.push({
          orgName: '',
          deptList: [],
        });

        this.selectedOrg = this.orgObjList.length - 1;
        this.radioClick(this.selectedOrg);
      },
      // 기관 삭제
      removeTab(index) {
        this.orgObjList.splice(index, 1);
        if (this.selectedOrg === index) {
          if (this.orgObjList.length - 1 > index) {
            this.selectedOrg = index;
          } else {
            this.selectedOrg = index - 1;
          }
        } else if (this.selectedOrg > index) {
          this.selectedOrg = this.selectedOrg - 1;
        }
        this.radioClick(this.selectedOrg);
      },
      // 부서 추가
      addDept() {
        this.deptObjList.push({
          deptChk: false,
          deptName: this.addDeptNm,
          deptDesc: [],
        });

        this.deptObjList[this.deptObjList.length - 1].deptDesc.push({
          position: this.addPosition,
          name: this.addName,
          tel: this.addTel,
          email: this.addEmail,
          history: this.addHistory,
        });
      },
      // 부서 담당자 추가
      add(index) {
        this.deptObjList[index].deptDesc.push({
          position: '',
          name: '',
          tel: '',
          email: '',
          history: '',
        });
      },
      // 부서 담당자 삭제
      remove(index, idx) {
        this.deptObjList[index].deptDesc.splice(idx, 1);

        if (this.deptObjList[index].deptDesc.length === 0) {
          this.deptObjList.splice(index, 1);
        }
      },
      // 조직도 html의 tag 값을 구분하여 변수에 셋팅
      parseHtml() {
        // 기관명 리스트 (조직도 모듈이 HTML이 아닌 페이지모듈(includeorgchart)이면 #tab-select가 없음)
        const tabSelect = document.getElementById('tab-select');
        if (!tabSelect) return;
        const tabList = tabSelect.childNodes;
        for (let i = 0; i < tabList.length; i += 1) {
          if (tabList.item(i).tagName === 'OPTION') {
            this.orgObjList.push({
              tapValue: tabList.item(i).value.substring(1, 6),
              orgName: tabList.item(i).textContent,
              deptList: [],
            });
          }
        }

        // 부서명, 부서내용 셋팅
        for (let i = 0; i < this.orgObjList.length; i += 1) {
          // Tab tag 찾기
          const tabValue = document.getElementById(this.orgObjList[i].tapValue);

          // tab 자식노드 DIV
          let divTagList = [];
          for (let j = 0; j < tabValue.childNodes.length; j += 1) {
            if (tabValue.childNodes.item(j).tagName === 'DIV') {
              divTagList = tabValue.childNodes.item(j).childNodes; // div tag의 하위
            }
          }

          // 부서명, 담당자 셋팅
          const deptListTemp = [];
          for (let j = 0; j < divTagList.length; j += 1) {
            // div tag 자식노드 중 DL tag
            if (divTagList.item(j).tagName === 'DL') {
              // dl tag 자식노드
              const dlTagList = divTagList.item(j).childNodes;

              // dl tag 자식노드 중 DT, DD 찾기
              for (let t = 0; t < dlTagList.length; t += 1) {
                // 부서명
                if (dlTagList.item(t).tagName === 'DT') {
                  // 부서명
                  deptListTemp.push({
                    deptChk: false,
                    deptName: dlTagList.item(t).textContent,
                    deptDesc: [],
                  });
                }

                // 부서내용
                if (dlTagList.item(t).tagName === 'DD') {
                  // dl tag 하위
                  const ddTagList = dlTagList.item(t).childNodes;
                  let positionTemp = '';
                  let nameTemp = '';
                  let telTemp = '';
                  let emailTemp = '';
                  let historyTemp = '';

                  for (let k = 0; k < ddTagList.length; k += 1) {
                    if (ddTagList.item(k).tagName === 'P') {
                      if (ddTagList.item(k).className === 'member-position') {
                        positionTemp = ddTagList.item(k).textContent;
                      } else if (ddTagList.item(k).className === 'member-name') {
                        nameTemp = ddTagList.item(k).textContent;
                      } else if (ddTagList.item(k).className === 'member-tel') {
                        telTemp = ddTagList.item(k).textContent;
                      } else if (ddTagList.item(k).className === 'member-email') {
                        emailTemp = ddTagList.item(k).textContent;
                      } else if (ddTagList.item(k).className === 'member-history') {
                        historyTemp = ddTagList.item(k).textContent;
                      }
                    }
                  }

                  const idx = deptListTemp.length;
                  deptListTemp[idx - 1].deptDesc.push({
                    position: positionTemp,
                    name: nameTemp,
                    tel: telTemp,
                    email: emailTemp,
                    history: historyTemp,
                  });

                  // 체크박스 체크 여부
                  if (deptListTemp[idx - 1].deptDesc.length > 1) {
                    deptListTemp[idx - 1].deptChk = true;
                  } else {
                    deptListTemp[idx - 1].deptChk = false;
                  }
                }
              }
            }
          }

          // 마지막 라인 제거
          if (deptListTemp.length > 0) {
            deptListTemp.splice(deptListTemp.length - 1, 1);
          }
          this.orgObjList[i].deptList = deptListTemp;
        }

        // 최초 화면 로딩시 1번 기관 선택
        if (this.selectedOrg === -1) {
          this.orgObjListIndex = window.sessionStorage.getItem('orgObjListSelect');
          if (this.orgObjListIndex === null) {
            this.selectedOrg = 0;
            this.radioClick(0);
          } else {
            this.selectedOrg = this.orgObjListIndex;
            this.radioClick(this.orgObjListIndex);
          }
        }
      },
      upSlides(obj, idx) {
        if (idx === 0) {
          alert('첫번째 입니다.');
          return;
        } else if (obj === 'org') {
          const temp = this.orgObjList[idx - 1];
          const temp2 = this.orgObjList[idx];
          this.orgObjList[idx - 1] = temp2;
          this.orgObjList[idx] = temp;
        } else if (obj === 'dept1') {
          const temp = this.orgObjList[this.selectedOrg].deptList[idx - 1];
          const temp2 = this.orgObjList[this.selectedOrg].deptList[idx];
          this.orgObjList[this.selectedOrg].deptList[idx - 1] = temp2;
          this.orgObjList[this.selectedOrg].deptList[idx] = temp;
        } else {
          const temp = this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx - 1];
          const temp2 = this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx];
          this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx - 1] = temp2;
          this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx] = temp;
        }
        window.sessionStorage.setItem('orgObjListSelect', this.selectedOrg);
        this.saveOrgInfo('pass');
      },
      downSlides(obj, idx) {
        if (obj === 'org') {
          if (idx === (this.orgObjList.length - 1)) {
            alert('마지막 입니다.');
            return;
          }
          const temp = this.orgObjList[idx + 1];
          const temp2 = this.orgObjList[idx];
          this.orgObjList[idx + 1] = temp2;
          this.orgObjList[idx] = temp;
        } else if (obj === 'dept1') {
          if (idx === (this.orgObjList[this.selectedOrg].deptList.length - 1)) {
            alert('마지막 입니다.');
            return;
          }
          const temp = this.orgObjList[this.selectedOrg].deptList[idx + 1];
          const temp2 = this.orgObjList[this.selectedOrg].deptList[idx];
          this.orgObjList[this.selectedOrg].deptList[idx + 1] = temp2;
          this.orgObjList[this.selectedOrg].deptList[idx] = temp;
        } else {
          if (idx === (this.orgObjList[this.selectedOrg].deptList[obj].deptDesc.length - 1)) {
            alert('마지막 입니다.');
            return;
          }
          const temp = this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx + 1];
          const temp2 = this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx];
          this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx + 1] = temp2;
          this.orgObjList[this.selectedOrg].deptList[obj].deptDesc[idx] = temp;
        }
        window.sessionStorage.setItem('orgObjListSelect', this.selectedOrg);
        this.saveOrgInfo('pass');
      },
    },
    created() {
      this.getOrgInfo();
    },
    mounted() {
      this.deptObjList.push({
        deptChk: false,
        deptName: '',
        deptDesc: [],
      });
      setTimeout(() => {
        this.parseHtml();
      }, 700);
    },
  };
</script>

<style lang="scss">
  .organization-table-edit { margin:20px 0 0 0; padding:0 0 50px 0; zoom:1; }
  .organization-table-edit:after {content:""; display:block; font-size:0; height:0px; clear:both; }
  .organization-table-edit .org-table-box { position:relative; min-height:34px; margin:8px 0 0 0; }
  .organization-table-edit .org-table-box .t-btn-box { position:absolute; top:0; right:0; width:62px; }
  .organization-table-edit .org-table-box .t-btn-box button { display:block; margin:0 0 4px 0; }
  .organization-table-edit .org-table-box .btn.btn--light-gray--org { border:1px solid #dbdbdb; }
  .organization-table-edit .org-table-box .btn.btn--light-gray--org:hover{border-color: #0096e0;  color: #0096e0; }
  .organization-table-edit .org-table-box .btn.btn--light-gray--org.active{background-color: #0096e0; color: #fff; border-color: #0096e0;}
  .organization-table-edit .org-table-box.org-table-box-input-1 { padding:0 65px 0 0; }
  .organization-table-edit .org-table-box.org-table-box-input-2 { padding:0 65px 0 40.3%; }
  .organization-table-edit .org-table-box.org-table-box-input-2 input.input__text { margin-bottom:2px; }
  .organization-table-edit .org-table-box .input-top-tit { position:absolute; top:0; left:0; width:40%; }
  .organization-table-edit .org-table-box .input-w40 { width:40%; }
  .organization-table-edit .org-table-box .input-w50 { width:50%; }
  .organization-table-edit .org-table-box .input-w55 { width:55%; }
  .organization-table-edit .org-table-box .input-w60 { width:60%; }
  .organization-table-edit .org-table-box .input-w70 { width:70%; }
  .organization-table-edit .org-table-box .input-w80 { width:80%; }
  .organization-table-edit .org-table-box textarea { height:95px; vertical-align:top; width:100%; }
  .organization-table-edit .abb-organization-table { margin:20px 0 0 0; }
  .organization-table-edit .abb-organization-table label { font-weight:normal; padding:0 0 2px 0; }
  .organization-table-edit .abb-organization-table label input { vertical-align:middle; margin:-2px 2px 0 0; }
  .organization-table-edit .org-table-box .input-m { margin:0 0 2px 0; }
  .btn.grey:not(.btn-outline) {
      color: #333;
      background-color: #E5E5E5;
      border-color: #E5E5E5;
  }
</style>



// WEBPACK FOOTER //
// OrgModification.vue?49f17cf1